import * as React from 'react'

const Find = (props: any) => {
  return (
    <svg
      {...props}
      className={'icon ' + props.className}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.81262 15.6252C12.1274 15.6252 15.6252 12.1274 15.6252 7.81262C15.6252 3.49783 12.1274 0 7.81262 0C3.49783 0 0 3.49783 0 7.81262C0 12.1274 3.49783 15.6252 7.81262 15.6252Z'
        transform='translate(.188 .188)'
        fill='#C4C4C4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.657227 8L0 7.32275L3.34277 3.87891L0.235352 0.677246L0.892578 0L4 3.20166L7.10742 0L7.76465 0.677246L4.65723 3.87891L8 7.32275L7.34277 8L4 4.55615L0.657227 8Z'
        transform='translate(4 4)'
        fill='#fff'
      />
    </svg>
  )
}

export default Find



// WEBPACK FOOTER //
// ./src/components/icons/ui/Cancel.tsx